const FAKE_LOGIN_KEY = 'f-login';
const FAKE_LOGINS_LIST_KEY = 'f-logins-list';
const FAKE_LOGINS_IDS_KEY = 'f-logins-ids';

const readJson = (storage, key, fallback) => {
  const raw = storage.getItem(key);
  if (!raw) {
    return fallback;
  }
  try {
    return JSON.parse(raw) ?? fallback;
  } catch {
    return fallback;
  }
};

export const readTokens = () => {
  const tokens = readJson(localStorage, 'jwt-tokens', {});
  return tokens && typeof tokens === 'object' && !Array.isArray(tokens) ? tokens : {};
};

export const readRefreshTokens = () => {
  const tokens = readJson(localStorage, 'jwt-refresh-tokens', {});
  return tokens && typeof tokens === 'object' && !Array.isArray(tokens) ? tokens : {};
};

export const saveToken = (token, email) => {
  let tokens = readTokens();
  tokens[email.toLowerCase()] = token;
  return localStorage.setItem('jwt-tokens', JSON.stringify(tokens));
};

export const saveFp = (fp, email) => {
  return localStorage.setItem(`${email.toLowerCase()}-user-fp`, fp);
};

export const getFp = (email) => {
  return localStorage.getItem(`${email}-user-fp`);
};

export const readToken = () => {
  const email = readUser();
  const tokens = readTokens();
  return email && tokens[email] ? tokens[email] : false;
};

export const readTokenForUser = (email) => {
  const tokens = readTokens();
  const key = email ? email.toLowerCase() : null;
  return key && tokens[key] ? tokens[key] : false;
};

export const deleteToken = () => {
  const email = readUser();
  let tokens = readTokens();
  if (!tokens || !email) {
    return;
  }
  delete tokens[email];
  return localStorage.setItem('jwt-tokens', JSON.stringify(tokens));
};

export const saveUser = ({ email }) => {
  return localStorage.setItem('current-user', email.toLowerCase());
};

export const readUser = () => {
  return localStorage.getItem('current-user');
};

export const deleteUser = () => {
  return localStorage.removeItem('current-user');
};

export const saveRefreshToken = (token, email) => {
  if (token) {
    let tokens = readRefreshTokens();
    tokens[email.toLowerCase()] = token;
    return localStorage.setItem('jwt-refresh-tokens', JSON.stringify(tokens));
  } else {
    return false;
  }
};

export const readRefreshToken = () => {
  const email = readUser();
  const tokens = readRefreshTokens();
  return email && tokens[email] ? tokens[email] : false;
};

export const deleteRefreshToken = () => {
  const email = readUser();
  const tokens = readRefreshTokens();
  if (!tokens || !email) {
    return;
  }
  delete tokens[email];
  return localStorage.setItem('jwt-refresh-tokens', JSON.stringify(tokens));
};

export const saveActiveRole = (role) => {
  return localStorage.setItem('role', role);
};

export const readActiveRole = () => {
  return localStorage.getItem('role');
};

export const deleteActiveRole = () => {
  return localStorage.removeItem('role');
};

export const readFakeLogin = () => {
  const sessionFakeLogin = readJson(sessionStorage, FAKE_LOGIN_KEY, null);
  if (sessionFakeLogin && typeof sessionFakeLogin === 'object' && !Array.isArray(sessionFakeLogin)) {
    return sessionFakeLogin;
  }
  const legacyFakeLogin = readJson(localStorage, FAKE_LOGIN_KEY, {});
  return legacyFakeLogin && typeof legacyFakeLogin === 'object' && !Array.isArray(legacyFakeLogin)
    ? legacyFakeLogin
    : {};
};

// Oldest first and never trimmed: the list also hides accounts whose tokens pre-#675 impersonation left in
// jwt-tokens from "Switch user". Only the menu caps what it shows.
const saveFakeLoginEntry = (userEmail, userId = null) => {
  const list = [...readFakeLoginsList().filter((email) => email !== userEmail), userEmail];
  localStorage.setItem(FAKE_LOGINS_LIST_KEY, JSON.stringify(list));

  if (userId) {
    const ids = readFakeLoginIds();
    ids[userEmail] = userId;
    localStorage.setItem(FAKE_LOGINS_IDS_KEY, JSON.stringify(ids));
  }
};

const buildFakeLoginContext = (adminEmail, userEmail, adminRole) => ({
  admin: adminEmail,
  user: userEmail,
  adminRole,
});

export const saveFakeLogin = (adminEmail = null, userEmail = null, userId = null, adminRole = null) => {
  if (!adminEmail || !userEmail) {
    sessionStorage.removeItem(FAKE_LOGIN_KEY);
    localStorage.removeItem(FAKE_LOGIN_KEY);
    return;
  }
  saveFakeLoginEntry(userEmail, userId);
  sessionStorage.setItem(FAKE_LOGIN_KEY, JSON.stringify(buildFakeLoginContext(adminEmail, userEmail, adminRole)));
};

export const saveFakeLoginForWindow = (targetWindow, adminEmail, userEmail, userId = null, adminRole = null) => {
  if (!adminEmail || !userEmail) {
    targetWindow.sessionStorage.removeItem(FAKE_LOGIN_KEY);
    return;
  }
  saveFakeLoginEntry(userEmail, userId);
  targetWindow.sessionStorage.setItem(
    FAKE_LOGIN_KEY,
    JSON.stringify(buildFakeLoginContext(adminEmail, userEmail, adminRole)),
  );
};

export const readFakeLoginsList = () => {
  const list = readJson(localStorage, FAKE_LOGINS_LIST_KEY, []);
  return Array.isArray(list) ? list : [];
};

export const readFakeLoginIds = () => {
  const ids = readJson(localStorage, FAKE_LOGINS_IDS_KEY, {});
  return ids && typeof ids === 'object' && !Array.isArray(ids) ? ids : {};
};

export const deleteFakeLoginEntry = (email) => {
  const list = readFakeLoginsList().filter((item) => item !== email);
  localStorage.setItem(FAKE_LOGINS_LIST_KEY, JSON.stringify(list));

  const ids = readFakeLoginIds();
  delete ids[email];
  localStorage.setItem(FAKE_LOGINS_IDS_KEY, JSON.stringify(ids));
};
